import api from './client';
import type { Tag, CreateTagRequest } from '../types';

export const tagApi = {
  list: () => api.get<Tag[]>('/api/tags'),
  create: (data: CreateTagRequest) => api.post<Tag>('/api/tags', data),
  delete: (id: string) => api.delete(`/api/tags/${id}`),
  forTicket: (ticketId: string) => api.get<Tag[]>(`/api/tickets/${ticketId}/tags`),
  addToTicket: (ticketId: string, tagId: string) =>
    api.post<Tag[]>(`/api/tickets/${ticketId}/tags/${tagId}`),
  removeFromTicket: (ticketId: string, tagId: string) =>
    api.delete<Tag[]>(`/api/tickets/${ticketId}/tags/${tagId}`),
};
